/**
 * "An authenticated API request just succeeded."
 *
 * Both fetch layers (react-fetching-library's interceptor and
 * @shared/api/client) report it here; the alerts hub listens. Kept as a
 * tiny module of its own so neither fetch layer has to import the hub
 * middleware, which imports the API endpoints, which import the client.
 *
 * Why the hub cares: with the refresh-on-request session (API branch
 * feature/auth-refresh-ttl) the JWT cookie is renewed by ordinary API
 * responses, while a hub connect with an expired cookie answers 410 and
 * the SignalR client never retries a failed initial start. So the hub
 * must start AFTER a successful request, never in parallel with the
 * first one, and come back after a drop on the next success.
 */
const listeners = new Set();

export const onAuthenticatedResponse = listener => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const notifyAuthenticatedResponse = () => {
  listeners.forEach(listener => {
    try {
      listener();
    } catch (error) {
      console.error('authenticated-response listener failed:', error);
    }
  });
};
